import { createContext, useContext } from "react";

import type {
  Traveller,
  TravellerAgeGroup,
} from "@/features/travellers/types/types";

export type TravellerSlots = Record<
  TravellerAgeGroup,
  readonly (string | null)[]
>;

export type TravellersSelectionContextValue = {
  travellerSlots: TravellerSlots;
  selectedTravellers: Traveller[];
  selectTraveller: (slotIndex: number, travellerId: string) => void;
  getTravellerIndex: (travellerId: string) => number | null;
};

export const TravellersSelectionContext =
  createContext<TravellersSelectionContextValue | null>(null);

export const useTravellersSelectionContext = () => {
  const context = useContext(TravellersSelectionContext);
  if (!context) {
    throw new Error(
      "useTravellersSelectionContext must be used within a TravellersSelectionProvider",
    );
  }
  return context;
};
